import { call, put, takeEvery } from "redux-saga/effects";
import AXIOS_INSTANCE from "../../utils/USOBConfig";

import {
  USOBVehicleTypesLoading,
  submitUSOBVehicleTypesActionDispatcher,
  submitUSOBVehicleTypesErrorDispatcher,
  SUBMIT_USOB_VEHICLE_TYPES_ACTION_REQUESTED,
} from "./Action"; // Path should come here

const postUSOBSegmentAPI = async (postData) => {
  const result = await AXIOS_INSTANCE.get("/vehicle-type")
    // console.log("result: ", result);
  return result ;
};

function* submitUSOBSegmentSaga({ postData }) {
  try {
    yield put(USOBVehicleTypesLoading(true));
    const data = yield call(postUSOBSegmentAPI, postData);
    yield put(submitUSOBVehicleTypesActionDispatcher(data));
    yield put(submitUSOBVehicleTypesErrorDispatcher({}));
    yield put(USOBVehicleTypesLoading(false));
  } catch (e) {
    yield put(submitUSOBVehicleTypesActionDispatcher({}));
    yield put(
      submitUSOBVehicleTypesErrorDispatcher(
        e.response.data,
        console.log(e.response)
      )
    );
    yield put(USOBVehicleTypesLoading(false));
  }
}

function* submitUSOBSegmentWatcher() {
  yield takeEvery(
    SUBMIT_USOB_VEHICLE_TYPES_ACTION_REQUESTED,
    submitUSOBSegmentSaga
  );
}
export default submitUSOBSegmentWatcher;
